module.exports = __webpack_public_path__ + "2524a3d7fc0cd767b7c31cbe1ec3b0ad.pdf";